import PreviousSearchModule from './previous-search/previous-search-module';
import WidgetsModule from './widgets/widgets-module';
import WrappersModule from './wrappers/wrappers-module';
import SearchCriteriaGroupItem from './search-criteria-group-item/search-criteria-group-item-module';
import TypeaheadDropdownModule from './typeahead-dropdown/typeahead-dropdown-module';
import DatepickerHightlighter from './datepicker-highlighter/datepicker-highlighter-module';
import Ordinal from './ordinal-filter';
import ServicesModule from './services/services-module';
import ModalModule from './modal/modal-module';
import SubmitOnParentSubmit from './directives/submit-on-parent-submit';
import ScreenDetectionModule from './screen-detection/screen-detection-module';
import ValidationWarningModule from './validation-warning/validation-warning-module';
import FormControlsEnabledModule from './form-controls-enabled/form-controls-enabled-module';
import FlightPreferredAirline from './flight-preferred-airline/flight-preferred-airline-module';

const MODULE_NAME = 'app.common';
const module = angular.module(MODULE_NAME, [
        PreviousSearchModule,
        WidgetsModule,
        WrappersModule,
        ServicesModule,
        ModalModule,
        DatepickerHightlighter,
        SearchCriteriaGroupItem,
        TypeaheadDropdownModule,
        ScreenDetectionModule,
        ValidationWarningModule,
        FormControlsEnabledModule,
        FlightPreferredAirline,
    ])
    .filter('ordinal', Ordinal)
    .directive('ktSubmitOnParentSubmit', SubmitOnParentSubmit);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/common/common-module.js